// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Barre de sélection du format d'étiquette */

.formContainer {
  text-align: center;
  margin-top: 3rem;
}

.form-selector {
  width: 500px;
  height: 50px;
  border-radius: 15px;
  font-family: sans-serif;
  font-size: 18px;
  background-color: black;
  color: white;
  padding-left: 10px;
  box-shadow: 0px 2px 5px grey;
  border: solid 1px white;
  appearance: none;
  cursor: pointer;
}

.form-selector:disabled {
  cursor: default;
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Selector.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":["/* Barre de sélection du format d'étiquette */\n\n.formContainer {\n  text-align: center;\n  margin-top: 3rem;\n}\n\n.form-selector {\n  width: 500px;\n  height: 50px;\n  border-radius: 15px;\n  font-family: sans-serif;\n  font-size: 18px;\n  background-color: black;\n  color: white;\n  padding-left: 10px;\n  box-shadow: 0px 2px 5px grey;\n  border: solid 1px white;\n  appearance: none;\n  cursor: pointer;\n}\n\n.form-selector:disabled {\n  cursor: default;\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
